import ExerciseDetail from './ExerciseDetail';

export default ExerciseDetail;
